export const DEMO_ACCOUNTS = ['demo@securif.ai',
    'omv-demo@securif.ai','orange@demo.com',"microsoft@demo.com", "bosch@demo.com", "aegeria@demo.ro"
    ];
export const LF_LOCATIONS = [
  4356, 4422, 4463, 4471, 4504, 4532, 4611, 4651, 4652, 4656, 4665, 4674, 4681, 4684, 4690, 4703, 4720, 4723, 4727, 4728, 4733, 4734, 4736, 4737,
  4738, 4739, 4747, 4751, 4753, 4756, 4768,
];
